import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import BsyAlertTextEdit from "../BsyAlertTextEdit";
import { BsyUtils } from "../../utils/Utils";
import BsyAlertQrcode from "../BsyAlertQrcode";
import BsyDashContainer from "../dash/BsyDashContainer";//编辑报表-发布新报表-内链
import BsySelect from "../BsySelect";
import DocumentTitle from "react-document-title";
import "./index.css";
import BsyDataManage from "../BsyDataManage";
import BsyFormPane from "../BsyFormPane";
import { BsyConfig } from "../../global/BsyConfig";
import { setPageTitle } from "../../utils/setPageTitle";
class BsyEntryView extends Component {
  static defaultProps = {
    mode: "teamlink",
  };

  constructor(props) {
    super(props);
    this.state = {
      formType: "form",
      isDashFull: false,
      rel: "and",
      dashConfig: {},
      isLoading: true,
      mode: props.mode,
      formAuthGroups: [],
    };
    this.dashView = React.createRef();
    this.$formcontent = React.createRef();
    this.$view = React.createRef();
    this.renderIndex = 0;
  }
  openPWD = () => {
    const { type } = this.state;
    BsyAlertTextEdit({
      title:
        type === "form"
          ? React.language("external.link.password.form")
          : React.language("external.link.password.dash"),
      noCancel: true,
      width: 350,
      onOk: (val, t) => {
        React.axios(`${window.FX.STATIC["DTOKEN"]}/password`, {
          publicPwd: val,
        })
          .then(() => {
            this.setState({ isPassPWD: true }, () => {
              this.loadDashViewData();
              t.closeAlter();
            });
            return true;
          })
          .catch(() => {
            return false;
          });
        return false;
      },
    });
  };

  onfullscreenchange = () => {
    let fullEl = BsyUtils.closestClass(this.dashView.current, "BsyEntryView");
    if (fullEl) {
      if (!document.fullscreenElement) {
        fullEl.classList.remove("fullScreen");
        fullEl.classList.remove("dash-theme-dark");
        this.setState({
          isDashFull: false,
        });
      }
    }
  };

  componentDidMount() {
    this.loadDashViewData();
  }
  _getEntryType = () => {
    var t = this.data.entry;
    if (t) {
      var e = "form" === t.type ? (t.hasCoop ? "coop" : "flow") : t.type;
      return e;
    }
  };
  _createHeader = () => {
    var t = this,
      e = this.props,
      i = this.data.entry;
    this.$header = window
      .$('<div className="header"/>')
      .appendTo(window.$(this.$view.current));
    if ("teamlink" === e.mode) {
      this.$header.addClass("team-link-header");
      var n = window.$('<div className="title"/>').appendTo(this.$header);

      switch (this._getEntryType()) {
        case "coop":
        case "flow":
          o = "icon-bby-form icon-bby-form-" + i.formIcon;
          break;
        case "report":
          o = "icon-bby-report icon-bby-form-" + i.formIcon;
          break;
        case "dash":
        case "scenes":
          o = "icon-bby-dash icon-bby-form-" + i.formIcon;
          break;
        default:
          o = "icon-bby-form icon-bby-form-" + i.formIcon;
      }
      n.prepend(window.$("<i/>").addClass(o));

      var s = window
        .$('<div className="qrcode-btn"/>')
        .append('<i className="icon-qrcode"/>')
        .click(function () {
          window.$(".qrcode-dropdown").remove();
          var t = window.$('<div className="qrcode-dropdown"/>');
          window
            .$("<div id ='qrcode' style='border:solid 10px #fff;' />")
            .appendTo(t);
          window.$("<div/>").text('微信"扫一扫"，分享给好友').appendTo(t);

          window.FX.Msg.bubble({
            anchor: s,
            text4Ok: null,
            text4Cancel: null,
            contentHTML: t,
            minWidth: 150,
            dockPosition: "right",
          });
          //替换 qrcode.min库
          var qrcode = new window.QRCode("qrcode", {
            text: window.location.href,
            width: 160,
            height: 160,
          });
        })
        .prependTo(this.$header);
    } else {
      var r = !1,
        o = window.$('<i className="icon-sidebar"/>');
      window
        .$('<div className="sidebar-container"/>')
        .append(
          window
            .$('<div className="icon-container"/>')
            .append(o)
            .on("click", function () {
              r = !r;
              window.$(o).toggleClass("icon-rotate", r);
              window.FX.Utils.applyFunc(t, e.onToggleMenu, [r], !1);
              setTimeout(function () {
                t.content && t.content.doResize(null, !0);
              }, 600);
            })
        )
        .prependTo(this.$header);
    }
  };

  _createContent = () => {
    var h = this;
    var t = this.props;
    this.$entryContent = window
      .$('<div className="entry-content"/>')
      .appendTo(window.$(this.$view.current));
    "teamlink" === t.mode && this.$entryContent.addClass("team-link-content");

    var e = this.data.entry;
    switch (e.type) {
      case "form":
        window.FX.STATIC.isSubmit = e.content.isSubmit;
        this._createFormViewSelector(
          window.$.extend({}, e, {
            flowConf: this.data.flow,
          }),
          this.data.authGroups
        );
        break;
      case "report":
        var i = window
          .$('<div className="scroll-layer">')
          .appendTo(this.$entryContent),
          a = e.content;

        this.content = new window.FX.Report(
          window.$.extend(a, {
            renderEl: window
              .$('<div className="report scrollable"/>')
              .appendTo(i),
            appId: e.appId,
            entryId: e.entryId,
            width: "100%",
            height: "100%",
            hasLazyLoad: !0,
          })
        );
        this._setEntryName();
        break;
      default:
    }
  };

  _createFormViewSelector = (t, e) => {
    var a, i, n, s, r, o, l;
    if (window.FX.Utils.isObjectEmpty(e)) {
      this._setEntryName();
      this._createFormView(t);
    } else {
      a = {};
      i = [];
      window.FX.Utils.forEach(e, function (t, e) {
        0 <= e.groupId &&
          i.push({
            text: e.name,
            value: e.groupId,
          });
        a[e.groupId] = e;
      });
      n = [];
      s = t.hasCoop
        ? window.FX.CONST.AUTH_GROUP_CONTENT
        : window.FX.CONST.FLOW_AUTH_GROUP_CONTENT;
      window.FX.Utils.forEach(s, function (t, e) {
        var i = a[e.groupId];
        window.FX.Utils.isNull(i) ||
          n.push({
            text: i.name,
            value: i.groupId,
          });
      });
      r = (i = n.concat(i))[0].value;
      o = window.FX.Store.getKey("authGroup", {
        appId: window.FX.STATIC.APPID,
        entryId: t.entryId,
      });
      l = window.FX.Store.get(o);
      window.FX.Utils.isNull(l) || (a[l] ? (r = l) : window.FX.Store.remove(o));
      this._setFormView(r, a, t);
      i.length <= 1
        ? this._setEntryName()
        : this._createAuthSelect({
          value: r,
          items: i,
          authGroupMap: a,
          attr: t,
          groupIdKey: o,
        });
    }

    // window.FX.Utils.isObjectEmpty(e) ? (this._setEntryName(), this._createFormView(t)) : (a = {},
    //   i = [],
    //   window.FX.Utils.forEach(e, function (t, e) {
    //     0 <= e.groupId && i.push({
    //       text: e.name,
    //       value: e.groupId
    //     }),
    //       a[e.groupId] = e
    //   }),
    //   n = [],
    //   s = t.hasCoop ? window.FX.CONST.AUTH_GROUP_CONTENT : window.FX.CONST.FLOW_AUTH_GROUP_CONTENT,
    //   window.FX.Utils.forEach(s, function (t, e) {
    //     var i = a[e.groupId];
    //     window.FX.Utils.isNull(i) || n.push({
    //       text: i.name,
    //       value: i.groupId
    //     })
    //   }),
    //   r = (i = n.concat(i))[0].value,
    //   o = FX.Store.getKey("authGroup", {
    //     appId: window.FX.STATIC.APPID,
    //     entryId: t.entryId
    //   }),
    //   l = FX.Store.get(o),
    //   window.FX.Utils.isNull(l) || (a[l] ? r = l : FX.Store.remove(o)),
    //   this._setFormView(r, a, t),
    //   i.length <= 1 ? this._setEntryName() : this._createAuthSelect({
    //     value: r,
    //     items: i,
    //     authGroupMap: a,
    //     attr: t,
    //     groupIdKey: o
    //   }))
  };
  _createAuthSelect = (t) => {
    var n = this,
      e = t.items,
      s = t.value,
      r = t.authGroupMap,
      o = t.attr,
      l = t.groupIdKey,
      c = window
        .$('<div className="form-view-selector"/>')
        .on("click", function () {
          var i = window
            .$('<div className="fui-entry-view-bubble"/>')
            .on("click", function (t) {
              var e,
                i = window.$(t.target).closest(".combo-item");
              if (i && i.length && !i.hasClass("select")) {
                i.addClass("select").siblings().removeClass("select");
                e = i.data("item");
                s = e.value;
                a.close();
                d.text(e.text);
                n._setFormView(s, r, o);
                window.FX.Store.set(l, s);
                // s === window.FX.CONST.DEFAULT_AUTH_GROUP && window.FX.Utils.dt(window.FX.CONST.TRACKER.AUTH_GROUP_DEFAULT_VISIT)
              }

              // i && i.length && !i.hasClass("select") && (i.addClass("select").siblings().removeClass("select"),
              //   e = i.data("item"),
              //   s = e.value,
              //   a.close(),
              //   d.text(e.text),
              //   n._setFormView(s, r, o),
              //   FX.Store.set(l, s),
              //   s === window.FX.CONST.DEFAULT_AUTH_GROUP && window.FX.Utils.dt(window.FX.CONST.TRACKER.AUTH_GROUP_DEFAULT_VISIT))
            });
          window.FX.Utils.forEach(e, function (t, e) {
            window
              .$('<div className="combo-item"/>')
              .text(e.text)
              .toggleClass("select", e.value === s)
              .toggleClass(
                "with-separator",
                e.value === window.FX.CONST.DEFAULT_AUTH_GROUP
              )
              .data("item", e)
              .append(
                '<div className="item-icon"><i className="icon-ok"/></div>'
              )
              .appendTo(i);
          });
          var a = window.FX.Msg.bubble({
            anchor: c,
            contentHTML: i,
            minWidth: 240,
            hasTriangle: !1,
            hAdjust: c.outerWidth() / 2 - 6,
            contentPadding: 0,
            text4Cancel: null,
            text4Ok: null,
          });
        })
        .appendTo(this.$header),
      d = window.$('<div className="name-text"/>').text(r[s].name).appendTo(c);
    window
      .$('<div className="icon-wrapper"><i className="icon-angledown"/></div>')
      .appendTo(c);
  };

  _setEntryName = () => {
    var t;
    if (this.$header && this.data && this.data.entry) {
      t = this.data.entry.name;
      this.$header.append(window.$('<div className="entry-name"/>').text(t));
    }
  };

  _setFormView = (t, e, i) => {
    var a = this,
      n = this.props;
    switch (t) {
      case window.FX.CONST.AUTH_GROUP.SUBMIT:
        this.form = a._createFormView(i, t);
        break;
      default:
        var s = e[t];
        if (!s) return;

        this.form && this.form.saveFormData();
        var r = window.FX.Store.getKey("showFields", {
          appId: window.FX.STATIC.APPID,
          entryId: i.entryId,
          groupId: t,
        }),
          o = window.FX.Store.getKey("metaFields", {
            appId: window.FX.STATIC.APPID,
            entryId: i.entryId,
            groupId: t,
          });
        this.content = new window.FX.DataManagePane({
          renderEl: window
            .$('<div className="data-manage"/>')
            .appendTo(a.$entryContent.empty()),
          appId: i.appId,
          entryId: i.entryId,
          formName: i.name,
          originPrint: "group",
          formItems: i.content.items,
          comment: i.comment,
          initializeModuleEvent: i.content.initializeModuleEvent,
          initializeDataExtendSet: i.content.initializeDataExtendSet,
          formAttr: {
            submitRule: i.content.submitRule,
            layout: i.content.layout,
            validators: i.content.validators,
            confirmSettings: i.content.confirmSettings,
            fieldShowRules: i.content.fieldShowRules,
            subformFieldShowRules: i.content.subformFieldShowRules,
            updateTime: i.updateTime,
          },
          flowConf: i.flowConf,
          hasFlowPrint: i.hasFlowPrint,
          hasExtParams: i.hasExtParams,
          // hasLastContent: i.submit_prompt.hasLastContent,
          hasCoop: i.hasCoop,
          hasFlow: i.hasCoop == false && i.hasFlow,
          dataPerms: s.dataPerms,
          optAuth: s.optAuth,
          authGroupId: t,
          isPublicData: i.isPublicData,
          publicDataUrlPrefix: n.publicDataUrlPrefix,
          printId: s.printId,
          prints: s.prints,
          showFields: window.FX.Store.get(r),
          showFieldsMeta: window.FX.Store.get(o),
          cacheEnable: n.cacheEnable && i.hasCache,
          // tabs: i.formTabs,
          formTabs: i.formTabs,
          formTabsStyle: i.formTabsStyle || {},
          formEvents: i.formEvents,
          mode: "visit",
          onDataFieldSelect: function (t) {
            window.FX.Store.set(r, t);
          },
          onDataFieldMetaChange: function (t) {
            window.FX.Store.set(o, t);
          },
          onDataPrint: function (t) {
            a._showFormPrint(t);
          },
        });
    }
  };
  _createFormView = (a, n) => {
    window.$(this.$formcontent.current).empty();
    this.$entryContent = window
      .$('<div className="entry-content"/>')
      .appendTo(window.$(this.$formcontent.current));

    var s = this,
      t = this.state;
    window.FX.STATIC.ENTRYID = a.entryId;
    window.FX.STATIC.APPID = a.appId;
    var e = {},
      i = !window.FX.Utils.isEmpty(a.flow && a.flow.flowVer);
    if (a.hasFlow && i) {
      e.forward = {
        text: window.FX.Utils.getFlowActionText("forward", a.flow),
      };
      a.flow.allowSave &&
        (e.save = {
          text: window.FX.Utils.getFlowActionText("save", a.flow),
        });
      a.hasFlowPrint &&
        (e.print = {
          text: window.FX.Utils.getFlowActionText("print", a.flow),
        });
    }

    var c = {
      renderEl: window
        .$('<div className="form"/>')
        .appendTo(this.$entryContent.empty()),
      appId: a.appId,
      entryId: a.entryId,
      flows: a.flow,
      hasFlow: a.hasCoop == false && a.hasFlow,
      hasFlowPrint: a.hasFlowPrint,
      printText:
        e.print && e.print.text
          ? e.print.text
          : React.language("flow.action.print"),
      authGroupId: n,
      cacheEnable: t.cacheEnable && a.hasCache,
      updateTime: a.updateTime,
      width: "100%",
      height: "100%",
      hasHeader: !1,
      submitText: React.language("flow.action.forward"),
      hasFooter: a.content
        ? a.content.isSubmit
          ? a.content.isSubmit === "yes"
            ? !0
            : !1
          : !0
        : !0,
      buttonPosition: "left",
      multiTabs: a.formTabs,
      formTabsStyle: a.formTabsStyle || {},
      formEvents: a.formEvents,
      onSuccess: function (t, e, i) {
        if (t && t.error_code) {
          var title = React.language("form.submit.fail.charger");
          var msg = React.language("form.submit.fail.charger.desc");
          if (t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND) {
            title = React.language("form.submit.fail.cond");
            msg = t.error_info; //;
          } else if (
            t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_SUBFLOW
          ) {
            title = React.language("form.submit.fail.subflow");
            msg = React.language("form.submit.fail.subflow.desc");
          } else if (
            t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_approval
          ) {
            title = React.language("form.submit.fail.approval");
            msg = React.language("form.submit.fail.approval.desc");
          }
          window.FX.Msg.alert({
            title: title,
            msg: msg,
            type: "warning",
            text4Cancel: null,
            text4Ok: React.language("iSee"),
          });
          return;
        }
        if (i) {
          s._showFormPrint(t.data);
          s.$entryContent.empty();
          window.FX.Utils.showSuccessInfo(c.$entryContent, t, function () {
            // window.FX.STATIC.IS_EVENT ? c._loadContentByAgainAdd(b) : c._createFormView(b);
          });
        } else {
          if (window.FX.Utils.hasHref()) {
            var hasBlank = window.FX.STATIC.FORMHREF.hasBlank;
            var data = window.$.extend(true, {}, arguments[3], t.retdata);
            window.FX.Utils.href(data);
            if (hasBlank) {
              s.$entryContent.empty();
              window.FX.Utils.showSuccessInfo(c.$entryContent, t, function () {
                // window.FX.STATIC.IS_EVENT ? c._loadContentByAgainAdd(b) : c._createFormView(b);
              });
            }
          } else {
            s.$entryContent.empty();
            window.FX.Utils.showSuccessInfo(s.$entryContent, t, function () {
              s._createFormView(a, n);
            });
          }
        }
      },
    };
    "teamlink" === t.mode &&
      window.$.extend(c, {
        width: 1080,
        height: null,
        // buttonPosition: "middle",
        multiTabScrollElement: this.$entryContent,
        onGetScrollContainer: function () {
          return s.$entryContent;
        },
      });
    this.content = new window.FX.Form(window.$.extend({}, a.content, c));
    return this.content;
  };
  _showFormPrint = (t) => {
    var e = window.FX.Utils.createLoadLayer(window.$("body"), {
      isLight: !0,
      isModal: !0,
    });
    new window.FX.FormEditPane({
      renderEl: window.$('<div className="x-shadow-content"/>').appendTo(e),
      height: "100%",
      appId: t.appId,
      dataId: t._id,
      originPrint: "flow",
      entryId: t.entryId,
      flowType: "print",
      flowId: 0,
      hasFlowBtn: !1,
      hasDataLog: !1,
      onCancel: function () {
        e.remove();
      },
    });
  };

  renderFormBody = () => {
    const { formConfig, authGroupId, authGroupMap } = this.state;

    return (
      <BsyFormPane
        formConfig={formConfig}
        authGroupId={authGroupId}
        hasHeader={false}
        loading={false}
        width={"80%"}
        mode={"new"}
      >
        {" "}
      </BsyFormPane>
    );
  };

  loadDashViewData() {
    const c = this;
    let e = {};
    let rel = this.state.rel;
    e.appId = this.props.match.params.appid;
    e.entryId = this.props.match.params.entryid;
    window.FX.STATIC.APPID = e.appId;
    window.FX.STATIC.ENTRYID = e.entryId;
    React.axios(`/dashboard/app/${e.appId}/entry/${e.entryId}`, {}).then(
      (res) => {
        const h = res ? res.data.entry : {};
        const AllH = res ? res.data : {};
        BsyUtils.forEach(h.components, (key, value) => {
          if (BsyUtils.isObjectEmpty(value)) {
            delete h.components[key];
          }
        })
        this.data = res ? res.data : {};
        setPageTitle(this.data.entry.name);
        window.FX.STATIC.PublicData = h.PublicData || {
          isPublicData: !1,
        };
        window.FX.STATIC.INNERLINK = h._id;
        if (!BsyUtils.isObjectEmpty(h.href)) {
          window.FX.STATIC.FORMHREF = h.href;
        } else {
          window.FX.STATIC.FORMHREF = null;
        }
        setPageTitle(h.name);
        switch (h.type) {
          case "form": {
            let groups = this._createFormViewSelector(h, res.data.authGroups);

            window.FX.STATIC.PublicData = h.PublicData || {
              isPublicData: !1,
            };
            c.setState(
              {
                isLoading: false,
                entryname: h.name,
                type: "form",
                showContentEmpty: true,
                page: 0,
                appId: e.appId,
                entryId: e.entryId,
                formAuthGroups: groups.formAuthGroups,
                authGroupId: groups.authGroupId,
                authGroupMap: groups.authGroupMap,
                formConfig: {
                  ...h,
                  appId: h.appId,
                  entryId: h.entryId,
                },
              },
              () => {
                // if (BsyUtils.isObjectEmpty(groups.authGroupId)) {
                //   this._createFormView(h)
                // } else {
                //   groups.authGroupId === -1 && this._setFormView(groups.authGroupId, groups.authGroupMap, h)
                // }
                // else {
                //     this._setFormView(groups.authGroupId, groups.authGroupMap, h);
                // }
              }
            );
            break;
          }
          case "report": {
            this.setState(
              {
                type: h.type,
                isLoading: false,
              },
              () => {
                this.$view.current.innerHTML = "";
                this._createHeader();
                this._createContent();
              }
            );

            break;
          }
          default: {
            rel = h.rel;
            if (!h.cacheFilter) {
              //清空缓存，筛选条件模式的默认值与缓存值不一致的情况
              let key = `dashFilterCache${h.appId}${h.entryId}`;
              if (BsyUtils.Store.has(key)) {
                BsyUtils.Store.remove(key);
              }
            } else {
              let key = `dashFilterCache${h.appId}${h.entryId}`;
              let filter = BsyUtils.Store.get(key);
              // console.log(key)
              // console.log(filter)
              if (filter && filter.rel) {
                rel = filter.rel;
              }
            }
            BsyUtils._getDashRequest(h);

            this.setState(
              {
                type: h.type,
                dashConfig: {
                  ...h,
                  appId: h.appId,
                  entryId: h.entryId,
                  hasLazyLoad: !0,
                },
                allComponentDash: {
                  ...AllH,
                  is_dock_form: res.data.is_dock_form,
                  appId: h.appId,
                  entryId: h.entryId,
                  hasLazyLoad: !0,
                },
                rel: rel,
                isLoading: false,
              },
              () => {
                // this.autoRefresh();
              }
            );
            break;
          }
        }
      }
    );
  }

  getDashContext = (context) => {
    this.bsyDashContext = context;
  };

  onFullDash = () => {
    const { dashConfig } = this.state;

    let fullEl = BsyUtils.closestClass(this.dashView.current, "BsyEntryView");
    if (fullEl) {
      if (fullEl.classList.contains("fullScreen")) {
        fullEl.classList.remove("fullScreen");
        fullEl.classList.remove("dash-theme-dark");

        // $(c.content.current).parent().parent().removeClass("fullScreen");
        // $(c.content.current).parent().parent().removeClass("dash-theme-dark");

        // $(".Full i", $(c.path.current)).removeAttr("class").addClass("icon-bsy-iconquanping")
        // $(".Full span", $(c.path.current)).text(React.language("fullScreen"))

        this.setState({
          isDashFull: false,
        }, () => {
          this.bsyDashContext && this.bsyDashContext.doResize();
        });
        window.dashSetInterval && clearInterval(window.dashSetInterval);
        this.bsyDashContext &&
          this.bsyDashContext._dealFilter &&
          this.bsyDashContext._dealFilter();
        // BsyUtils.exitFullscreen();
      } else {
        fullEl.classList.add("fullScreen");
        if (
          dashConfig.styles &&
          dashConfig.styles.theme.name != "preset_style_light_1"
        ) {
          // $(c.content.current).parent().parent().addClass("dash-theme-dark");
          fullEl.classList.add("dash-theme-dark");
        }
        // $(".Full i", $(c.path.current)).removeAttr("class").addClass("icon-bsy-iconsuoxiao")
        // $(".Full span", $(c.path.current)).text(React.language("exitfullScreen"))

        this.setState(
          {
            isDashFull: true,
          },
          () => {
            this.bsyDashContext && this.bsyDashContext.doResize();
            this.autoRefresh();
          }
        );

        // if (dashConfig.autoRefresh && dashConfig.autoRefresh.enabled) {
        //   const appId = dashConfig.appId;
        //   let data = [];
        //   let formIdList = [];
        //   BsyUtils.forEach(dashConfig.components, (key, val) => {
        //     if (!val) {
        //       return;
        //     }
        //     if (!val.forms) {
        //       return;
        //     }
        //     if (!val.forms[0]) {
        //       return;
        //     }
        //     if (formIdList.indexOf(val.forms[0]) < 0) {
        //       if (val.forms[0].indexOf("@") > -1) {
        //         data.push({
        //           appId: val.forms[0].split("@")[1],
        //           formId: val.forms[0].split("@")[0]
        //         })
        //       } else {
        //         data.push({
        //           appId,
        //           formId: val.forms[0]
        //         })
        //       }
        //       formIdList.push(val.forms[0])
        //     }
        //   })
        //   let timeNum = dashConfig.autoRefresh.autoRefreshTime;
        //   if (dashConfig.autoRefresh.autoRefreshTime === "custom") {
        //     timeNum = dashConfig.autoRefresh.autoRefreshTimeNum;
        //   }
        //   React.axios("/data/get_update_time", data).then((res) => {
        //     this.updateTime = res.data;
        //     this.bsyDashContext && this.bsyDashContext._dealFilter && this.bsyDashContext._dealFilter();
        //     window.dashSetInterval = setInterval(() => {
        //       React.axios("/data/get_update_time", data).then((res) => {
        //         let flg = false;
        //         for (let i = 0; i < res.data.length; i++) {
        //           if (res.data[i].updateTime !== this.updateTime[i].updateTime) {
        //             flg = true;
        //             this.bsyDashContext && this.bsyDashContext._dealFilter && this.bsyDashContext._dealFilter(false, "isFull", res.data[i])
        //           }
        //         }
        //         if (flg) {
        //           this.updateTime = res.data;
        //           window.dashSetInterval && clearInterval(window.dashSetInterval);
        //         }
        //       }).catch(res => {
        //         console.log(res)
        //       })
        //     }, timeNum * 1000)
        //   }).catch(res => {
        //     console.log(res)
        //   })

        // }
        // document.removeEventListener(
        //   "fullscreenchange",
        //   this.onfullscreenchange,
        //   false
        // );
        // document.addEventListener(
        //   "fullscreenchange",
        //   this.onfullscreenchange,
        //   false
        // );
        BsyUtils.requestFullScreen(() => {
          this.onfullscreenchange()
        });
      }
    }
  };

  autoRefresh = () => {
    const { dashConfig } = this.state;
    if (dashConfig.autoRefresh && dashConfig.autoRefresh.enabled) {
      const appId = dashConfig.appId;
      let data = [];
      let formIdList = [];
      //缓存所有表单ID 用于后续判断 刷新的逻辑
      BsyUtils.forEach(dashConfig.components, (key, val) => {
        if (!val) {
          return;
        }
        if (!val.forms) {
          return;
        }
        if (!val.forms[0]) {
          return;
        }
        if (formIdList.indexOf(val.forms[0]) < 0) {
          if (val.forms[0].indexOf("@") > -1) {
            data.push({
              appId: val.forms[0].split("@")[1],
              formId: val.forms[0].split("@")[0],
            });
          } else {
            data.push({
              appId,
              formId: val.forms[0],
            });
          }
          formIdList.push(val.forms[0]);
        }
      });
      let timeNum = this.state.dashConfig.autoRefresh.autoRefreshTime;
      if (this.state.dashConfig.autoRefresh.autoRefreshTime === "custom") {
        timeNum = this.state.dashConfig.autoRefresh.autoRefreshTimeNum;
      }
      React.axios("/data/get_update_time", data)
        .then((res) => {
          this.updateTime = res.data;
          this.bsyDashContext &&
            this.bsyDashContext._dealFilter &&
            this.bsyDashContext._dealFilter();
          window.dashSetInterval = setInterval(() => {
            React.axios("/data/get_update_time", data)
              .then((res) => {
                let flg = false;
                for (let i = 0; i < res.data.length; i++) {
                  if (
                    res.data[i].updateTime !== this.updateTime[i].updateTime
                  ) {
                    flg = true;
                    this.bsyDashContext &&
                      this.bsyDashContext._dealFilter &&
                      this.bsyDashContext._dealFilter(
                        false,
                        "isFull",
                        res.data[i]
                      );
                  }
                }
                if (flg) {
                  this.updateTime = res.data;
                  if (window.dashSetInterval) {
                    clearInterval(window.dashSetInterval);
                    window.dashSetInterval = null;
                  }
                }
              })
              .catch((res) => {
                console.log(res);
              });
          }, timeNum * 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    }
  };

  openQrcode = (event) => {
    event.stopPropagation();
    const { dashConfig } = this.state;
    const pot = event.currentTarget.getBoundingClientRect();
    const css =
      160 >
        document.documentElement.clientHeight -
        pot.top +
        event.currentTarget.offsetHeight +
        2
        ? {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          bottom: document.documentElement.clientHeight - pot.top + 2 + "px",
        }
        : {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          top: pot.top + event.currentTarget.offsetHeight + 2 + "px",
        };
    let theme = "";
    if (
      dashConfig.styles &&
      dashConfig.styles.theme &&
      dashConfig.styles.theme.name
    ) {
      theme = dashConfig.styles.theme.name;
    }
    BsyAlertQrcode({
      value: window.location.href, //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,
      theme: theme,
      text: React.language("msg.qrCode"),
      fgColor:
        theme === "preset_style_dark_3" || theme === "preset_style_dark_1"
          ? "#29314c"
          : "#000000",
    });
  };

  onResetRel = (t) => {
    if (this.bsyDashContext && this.bsyDashContext.setRel)
      this.bsyDashContext.setRel(t);
  };

  onResetFilter = (t) => {
    this.bsyDashContext.ResetFilter();
  };

  renderDataTable = (data) => {
    const { formConfig, entryId, type, appId, authGroupId, authGroupMap } =
      this.state;

    if (BsyUtils.isObjectEmpty(authGroupId)) {
      return this.renderFormBody();
    }
    if (authGroupId === -1) {
      return this.renderFormBody();
    }
    if (authGroupMap && !authGroupMap[authGroupId]) {
      return this.renderFormBody();
    }

    let f = authGroupMap[authGroupId];

    let ptlist = [];
    if (f.printId) {
      BsyUtils.forEach(f.printId, function (k, v) {
        ptlist.push({
          printId: k,
          name: v.name,
        });
      });
    }

    let showFields = [];
    window.$.map(f.optAuth, function (v, k) {
      if (v.visible) showFields.push(k);
    });
    let g = window.FX.Store.getKey("paramFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var h = window.FX.Store.getKey("showFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var i = window.FX.Store.getKey("metaFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    window.FX.STATIC.DECISION_SWITCH =
      formConfig.flow &&
        formConfig.flow.decision &&
        formConfig.flow.decision.switch
        ? formConfig.flow.decision.switch
        : false;

    let config = {
      appId: formConfig.appId,
      entryId: formConfig.entryId,
      formName: formConfig.name,
      formTabs: formConfig.formTabs,
      formTabsStyle: formConfig.formTabsStyle || {},
      formItems: formConfig.content.items,
      submitAttr: formConfig.content.submitAttr,
      data_cache: formConfig.content.data_cache,
      initializeModuleEvent: formConfig.content.initializeModuleEvent,
      initializeDataExtendSet: formConfig.content.initializeDataExtendSet,
      formAttr: {
        submitRule: formConfig.content.submitRule,
        layout: formConfig.content.layout,
        validators: formConfig.content.validators,
        confirmSettings: formConfig.content.confirmSettings,
        fieldShowRules: formConfig.content.fieldShowRules,
        subformFieldShowRules: formConfig.content.subformFieldShowRules,
      },
      originPrint: "group",
      enableRowEdit: formConfig.enableRowEdit,
      quickEdit: formConfig.quickEdit,

      hasExtParams: formConfig.hasExtParams,
      hasUserSource: formConfig.hasUserSource === true,
      hasFlow: formConfig.hasFlow,
      hasCoop: formConfig.hasCoop,
      flow: formConfig.flow,
      dataPerms: f.dataPerms,
      optAuth: f.optAuth,
      ptlist: ptlist,
      authGroupId: authGroupId,
      showFieldsFilter: window.FX.Store.get(g),
      showFields: window.FX.Store.get(h),
      showFieldsMeta: window.FX.Store.get(i),
      printId: f.printId,
      onParamFieldSelect: function (a) {
        window.FX.Store.set(g, a);
      },
      onDataFieldSelect: function (a) {
        window.FX.Store.set(h, a);
      },
      onDataFieldMetaChange: function (a) {
        window.FX.Store.set(i, a);
      },
    };

    return <BsyDataManage {...config} />;
  };

  _createFormViewSelector = (b, c, appId) => {
    let d = this;
    window.FX.STATIC.isSubmit = b.content.isSubmit;
    if (window.FX.Utils.isObjectEmpty(c)) {
      return [];
    }
    // return void this._createFormView(b);
    let e = {},
      f = [];
    BsyUtils.forEach(c, function (a, b) {
      b.groupId >= 0 &&
        f.push({
          text: b.name,
          value: b.groupId,
          customCls: b.groupId === 0 ? "all-permission" : undefined,
        });
      e[b.groupId] = b;
    });
    let g = [],
      h = {
        "-1": React.language("auth.group.submit.name"),
        "-4": React.language("auth.group.manage.name"),
        "-3": React.language("auth.group.manageOwn.name"),
        "-2": React.language("auth.group.review.name"),
      };
    if (!b.hasCoop) {
      h = {
        "-1": React.language("flow.launch"),
        "-4": React.language("flow.auth.group.manage.name"),
        "-2": React.language("flow.auth.group.review.name"),
      };
    }
    BsyUtils.forEach(h, function (a, b) {
      let c = e[a];
      c &&
        g.push({
          text: b,
          value: c.groupId,
        });
    });
    f = g.concat(f);
    let i = f[0].value;
    let j = BsyUtils.Store.getKey("authGroup", {
      appId: b.appId,
      entryId: b.entryId,
    });
    let k = BsyUtils.Store.get(j);
    if (BsyUtils.isNull(k) || (e[k] ? (i = k) : BsyUtils.Store.remove(j))) {
      // d._setFormView(i, e, b);
      if (f.length > 0) {
        const bb = f.map((d) => {
          d.selected = false;
          if (d.value === i) d.selected = true;
          return d;
        });
        f = bb;
      }
    }
    if (f.length === 1) {
      if (f[0].value === -1) {
        return {
          formAuthGroups: [],
          authGroupMap: e,
          authGroupId: i,
        };
      }
    }
    return {
      formAuthGroups: f,
      authGroupMap: e,
      authGroupId: i,
    };
  };
  openQrcode = (event) => {
    event.stopPropagation();

    const pot = event.currentTarget.getBoundingClientRect();
    const css =
      160 >
        document.documentElement.clientHeight -
        pot.top +
        event.currentTarget.offsetHeight +
        2
        ? {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          bottom: document.documentElement.clientHeight - pot.top + 2 + "px",
        }
        : {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          top: pot.top + event.currentTarget.offsetHeight + 2 + "px",
        };
    BsyAlertQrcode({
      value: window.location.href, //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,

      text: React.language("msg.qrCode"),
      fgColor: "#000000",
    });
  };

  renderForm = () => {
    const {
      isDashFull,
      rel,
      dashConfig,
      allComponentDash,
      isLoading,
      type,
      formAuthGroups,
      authGroupId,
      appId,
      entryId,
      authGroupMap,
      formConfig,
      entryname,
    } = this.state;
    switch (type) {
      case "form": {
        return (
          <>
            <div className="header team-link-header">
              <div className="qrcode-btn" onClick={this.openQrcode}>
                <i className="icon-qrcode"></i>
              </div>
              <div className="title">
                <i className="icon-bby-form icon-bby-form-0"></i>
              </div>

              {BsyUtils.isObjectEmpty(formAuthGroups) ? (
                <div className="form-view-selector">
                  <div className="name-text">{entryname}</div>
                </div>
              ) : (
                <BsySelect
                  customCls={" form-view-selector "}
                  allowBlank={false}
                  searchable={false}
                  width={200}
                  value={authGroupId}
                  items={formAuthGroups}
                  onStopEdit={(val) => {
                    const bb = formAuthGroups.map((d) => {
                      d.selected = false;
                      if (d.value === val) d.selected = true;
                      return d;
                    });
                    this.renderIndex++;

                    this.setState(
                      {
                        authGroupId: val,
                        formAuthGroups: bb,
                      },
                      () => {
                        let j = BsyUtils.Store.getKey("authGroup", {
                          appId: appId,
                          entryId: entryId,
                        });
                        BsyUtils.Store.set(j, val);
                        if (val === -1) {
                          // this._setFormView(val, authGroupMap, formConfig)
                        }
                      }
                    );
                  }}
                ></BsySelect>
              )}
            </div>
            <div
              className="entry-content team-link-content"
              ref={this.$formcontent}
              key={"render-" + this.renderIndex}
            >
              {this.renderDataTable()}
            </div>
          </>
        );

        break;
      }
      case "report": {
        break;
      }
      default: {
        const that = this;
        let theme = "";
        if (
          dashConfig.styles &&
          dashConfig.styles.theme &&
          dashConfig.styles.theme.name
        ) {
          theme = dashConfig.styles.theme.name;
        }
        let rootTokenDashClass =
          "rootTokenDashClass" +
          this.props.match.params.appid +
          this.props.match.params.entryid;

        var cddashConfig = Object.fromEntries(Object.entries(dashConfig.components).filter(([key1, val]) => {
          return !val['parentsId']
        }))


        return (
          <>
            <div className="dashView-header">
              <div className="dashView-name">{dashConfig.name}</div>
              <div className="dashView-funBtn">
                {dashConfig.showFilter ? (
                  <>
                    <div
                      className="dash-filter-rel"
                      data-tip={
                        rel === "and"
                          ? React.language("reset.filter.and.tip")
                          : React.language("reset.filter.or.tip")
                      }
                      data-place={"bottom"}
                      data-type={window.mode}
                      data-html={true}
                    >
                      <BsySelect
                        allowBlank={false}
                        searchable={false}
                        value={rel}
                        theme={theme}
                        items={[
                          {
                            value: "and",
                            text: React.language("filter.rel.and"),
                          },
                          {
                            value: "or",
                            text: React.language("filter.rel.or"),
                          },
                        ]}
                        onStopEdit={(val) => {
                          that.onResetRel(val);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  ""
                )}
                {dashConfig.cacheFilter ? (
                  <>
                    <div
                      data-tip={React.language("reset.filter")}
                      data-place={"bottom"}
                      data-type={window.mode}
                      data-html={true}
                      className="dash-filter-reset"
                      onClick={that.onResetFilter}
                    >
                      <i className={"icon-async"} />
                      <span>{React.language("richtext.reset")}</span>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div
                  className="form-view Full"
                  onClick={this.onFullDash}
                  onMouseEnter={(event) => {
                    if (
                      this.bsyDashContext.props.autoRefresh &&
                      this.bsyDashContext.props.autoRefresh &&
                      this.bsyDashContext.props.autoRefresh.enabled
                    ) {
                      window.FX.UI.showPopover({
                        position: "bottomLeft",
                        anchor: window.$(event.target),
                        content: window
                          .$("<span/>")
                          .text(React.language("dash.full.autoRefresh.tip")),
                        type: "dark",
                      });
                    }
                  }}
                  onMouseLeave={() => {
                    window.FX.UI.closePopover();
                  }}
                >
                  <i
                    className={
                      isDashFull
                        ? "icon-bsy-iconsuoxiao"
                        : "icon-bsy-iconquanping"
                    }
                  />
                  <span>
                    {isDashFull
                      ? React.language("exitfullScreen")
                      : React.language("fullScreen")}
                  </span>
                </div>
                <div className="view-qrcode" onClick={this.openQrcode}>
                  <i className="icon-qrcode"></i>
                </div>
              </div>
            </div>
            <div className="dashView-body" ref={this.dashView}>
              <BsyDashContainer
                // key={`dash${dashConfig.appId}${dashConfig.entryId}`}
                {...dashConfig}
                components={cddashConfig}
                allComponentDash={allComponentDash}
                showType="dashView"
                isDashFull={isDashFull}
                rel={rel}
                rootTokenDashclassName={rootTokenDashClass}
                getContext={this.getDashContext}
              />
            </div>
          </>
        );
      }
    }
  };

  render() {
    const { dashConfig, isLoading } = this.state;
    setPageTitle(dashConfig.name);
    return (
      <>
        {!isLoading && (

          <div className="BsyEntryView" ref={this.$view}>
            {this.renderForm()}
          </div>

        )}
      </>
    );
  }
}

export default withRouter(BsyEntryView);
